import { device } from "shared/constants/device";
import styled from "styled-components";

export const MainContainer = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 4px;
  padding: 16px;
  min-height: 400px;
`
export const LayoutInternalContainerInner = styled.div`
  width:calc(100% - 240px);
  flex: 1 1 auto;
  @media ${device.tablet} {
    width:100%;
    margin-top: 20px;
  }
`

